import { render } from "./FreightInfo.vue?vue&type=template&id=9c439f2c&scoped=true"
import script from "./FreightInfo.vue?vue&type=script&lang=js"
export * from "./FreightInfo.vue?vue&type=script&lang=js"

import "./FreightInfo.vue?vue&type=style&index=0&id=9c439f2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c439f2c"]])

export default __exports__